import axios from "axios";
import apiUrl from "../Apiurl";

// Quote dei canali di traduzione (T27): Google e Azure separati, ordine della
// cascata e servizi selezionabili. Fonte: GET /prodotti/translate/quote.

const numero = new Intl.NumberFormat("it-IT");
export const formatCaratteri = (value) => (value === null || value === undefined ? "illimitato" : numero.format(value));

export async function loadTranslationChannels(getAccessTokenSilently, signal) {
  const token = await getAccessTokenSilently();
  const response = await axios.get(`${apiUrl}/prodotti/translate/quote`, { headers: { Authorization: `Bearer ${token}` }, signal });
  if (!response.data?.success || !Array.isArray(response.data.data?.canali)) throw new Error("Quote dei servizi di traduzione non disponibili.");
  return response.data.data;
}

/**
 * Parti di quota da mostrare: per ogni canale la parte gratuita e, se esiste,
 * quella a consumo. Il registro consuma prima la gratuita.
 */
export function partiQuota(canali = []) {
  return canali.flatMap((canale) => {
    const nome = canale.provider === "azure" ? "Azure" : canale.canale === "google-llm" ? "Google LLM" : "Google";
    const parti = [];
    if (canale.gratuito > 0) {
      parti.push({ id: `${canale.canale}-gratuita`, etichetta: `${nome} gratuito`, usati: Math.min(canale.consumate, canale.gratuito),
        totale: canale.gratuito, residuo: canale.esaurito ? 0 : Math.max(0, canale.gratuito - canale.consumate), credenziali: canale.credenziali });
    }
    if (canale.consumo === null || canale.consumo > 0) {
      const usati = Math.max(0, canale.consumate - canale.gratuito);
      parti.push({ id: `${canale.canale}-consumo`, etichetta: `${nome} a consumo`, usati, totale: canale.consumo,
        residuo: canale.consumo === null ? null : Math.max(0, canale.consumo - usati), credenziali: canale.credenziali });
    }
    return parti;
  });
}

const NOMI_STADI = { gratuita: "gratuito", consumo: "a consumo" };
export function ordineCascata(quote) {
  const stadi = quote?.cascata?.stadi || [];
  return stadi.map((stadio) => `${stadio.canale.startsWith("azure") ? "Azure" : "Google"} ${NOMI_STADI[stadio.parte] || stadio.parte}`).join(" → ");
}
